// extracted by extract-css-chunks-webpack-plugin
module.exports = {"loading-screen":"LoadingScreen-module_loading-screen__2RJFy"};